import {
  Component,
  computed,
  effect,
  Input,
  input,
  OnInit,
  signal,
} from '@angular/core';
import { PatientModel, SkillAreaModel } from '../../core/api/models';
import { SupervisorApiService } from '../../core/api/services';
import { AlertService } from '../../shared/services/alert.service';
import { SupervisorHelperService } from '../supervisor.helper.service';
import { Utils } from '../../core/utils';
import { SelectItemGroup } from 'primeng/api';
import { Router } from '@angular/router';
@Component({
  selector: 'app-skill-areas',
  templateUrl: './skill-areas.component.html',
  styleUrl: './skill-areas.component.css',
  standalone: false,
})
export class SkillAreasComponent implements OnInit {
  patientID = input.required<string>();

  loadingSkillAreas: boolean = false;

  searchKeyword = signal<string | null>(null);
  includeDeleted = signal<boolean>(false);

  filteredSkillAreas = computed(() => {
    let filteredSkillAreas = this.supervisorHelperService.skillAreas();

    //Avoid loading worng skill areas
    if (filteredSkillAreas && filteredSkillAreas.length > 0 && filteredSkillAreas[0].PatientID != Number(this.patientID())) {
      console.log('filteredSkillAreas computed: wrong patientID');
      this.loadData();
      return [];
    }

    if (this.searchKeyword() != null && this.searchKeyword() != '') {
      filteredSkillAreas = filteredSkillAreas.filter((skillArea) =>
        skillArea.SkillAreaName?.toLowerCase().includes(
          this.searchKeyword()!.toLowerCase()
        )
      );
    }
    if (!this.includeDeleted()) {
      filteredSkillAreas = filteredSkillAreas.filter(
        (skillArea) => !skillArea.IsDeleted
      );
    }
    return filteredSkillAreas;
  });

  constructor(
    private supervisorApiService: SupervisorApiService,
    private alertService: AlertService,
    private supervisorHelperService: SupervisorHelperService,
    private router: Router
  ) {
    effect(() => {
      console.log(
        'update signal triggered: ',
        this.supervisorHelperService.updateSignal()
      );
      this.loadData();
    });
  }

  ngOnInit(): void {
    console.log('SkillAreasComponent ngOnInit');
    if (this.patientID()) {
      this.loadData();
    } else {
      this.router.navigate(['/select-patient']);
    }
  }

  loadData() {
    this.loadingSkillAreas = true;
    this.supervisorApiService
      .GetSkillAreas({ patientID: Number(this.patientID()) })
      .subscribe(
        (skillAreas) => {
          this.loadingSkillAreas = false;
          this.supervisorHelperService.skillAreas.set(skillAreas);
        },
        (err) => {
          this.loadingSkillAreas = false;
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }

  toggleIncludeDeleted() {
    this.includeDeleted.set(!this.includeDeleted());
  }

  clearSearch() {
    this.searchKeyword.set(null);
    this.includeDeleted.set(false);
  }

  addSkillAreaButtonClicked() {
    console.log('addSkillAreaButtonClicked');
    this.supervisorHelperService.addSkillAreaButtonClicked(null);
  }

  getFromBSPButtonClicked() {
    console.log('getFromBSPButtonClicked');
    this.supervisorApiService
      .ImportSkillAreasFromBSP({ patientID: Number(this.patientID()) })
      .subscribe(
        (response) => {
          console.log('ImportSkillAreasFromBSP response: ', response);
          this.loadData();
        },
        (err) => {
          this.alertService.error(Utils.getErrorMessageFromErrorResponse(err));
        }
      );
  }
}
